var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "communityRule", "data-role": "page" } }, [
    _c(
      "div",
      {
        staticClass: "communityRule-content",
        attrs: { "data-position": "fixed" }
      },
      [
        _c("div", { staticClass: "detailWrap" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "detail-c" }, [
            _c(
              "ul",
              { staticClass: "collapse-ul-list rule-list" },
              _vm._l(_vm.Rules, function(rule, rule_ind) {
                return _c(
                  "li",
                  {
                    key: rule_ind,
                    attrs: { id: "Wrap" + rule_ind },
                    on: {
                      click: function($event) {
                        _vm.openWrap(rule_ind)
                      }
                    }
                  },
                  [
                    _c("a", { staticClass: "title" }, [
                      _c("div", { staticClass: "info" }, [
                        _c("h4", [_vm._v(_vm._s(rule.rule_name))])
                      ]),
                      _vm._v(" "),
                      _c("i", { staticClass: "icon-dropdown triggerIcon" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "triggerWrap" }, [
                      _c(
                        "ul",
                        { staticClass: "collapse-ul-sublist" },
                        [
                          _c("li", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://storage.googleapis.com/kingnetcare/CHK/committee/rule_template/" +
                                    rule.file,
                                  target: "_blank"
                                }
                              },
                              [_vm._v("詳細全文")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(rule.ruleList, function(list, list_ind) {
                            return _c("li", { key: list_ind }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://storage.googleapis.com/kingnetcare/CHK/committee/rule_template/" +
                                      list.file
                                  }
                                },
                                [_vm._v(_vm._s(list.rule_name))]
                              )
                            ])
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              })
            ),
            _vm._v(" "),
            _c("p", { staticClass: "tips" }, [
              _vm._v("以內政部最新公告之版本為準" + _vm._s(_vm.errmsg))
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-h" }, [
      _c("h3", [_vm._v("公寓大廈規約範本")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "qk-link" }, [
      _c("div", { staticClass: "qk-link-wrap-col1" }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.cpami.gov.tw/%E6%9C%80%E6%96%B0%E6%B6%88%E6%81%AF/%E6%B3%95%E8%A6%8F%E5%85%AC%E5%91%8A/10474-%E5%85%AC%E5%AF%93%E5%A4%A7%E5%BB%88%E8%A6%8F%E7%B4%84%E7%AF%84%E6%9C%AC.html"
            }
          },
          [_c("div", [_c("span", [_vm._v("資料來源")])])]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d010245", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d010245","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/communityRule.vue
// module id = null
// module chunks = 